// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3638) return "static/chunks/3638-df38230e925e0406.js";
	if (chunkId === 284) return "static/chunks/284-fbe2b1fb03f7364a.js";
	if (chunkId === 4775) return "static/chunks/4775-5f70f96bf2caf47d.js";
	if (chunkId === 9688) return "static/chunks/9688-3bb6a77452c94d67.js";
	if (chunkId === 3012) return "static/chunks/3012-c8517d1e40b365d2.js";
	if (chunkId === 3662) return "static/chunks/29107295-b133b9f0bd8c6f37.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2336 ? "bf15807c" : chunkId) + "." + {"2336":"8177a407d64f4e22","3362":"b288e3fb31540926","3936":"1627501d538e4cb9","5025":"906fe6be2faccbeb","6450":"b305959dd93d97da","8070":"e149987db20dd446","9897":"3049e104787def81"}[chunkId] + ".js";
};